/* AMC homepage mobile-only progressive disclosure, 2026-10-10.
   Content stays in its original DOM and is completely restored at desktop width.
   Works without this script (directories remain openly visible). */
(() => {
  'use strict';
  if (window.__amcMobileHomePolish20261010) return;
  window.__amcMobileHomePolish20261010 = true;
  const mq = window.matchMedia('(max-width: 749px)');
  const selectors = [
    {selector: '.amc-resource-panel--guides .amc-resource-panel__link-grid', label: 'Explore buying guides'},
    {selector: '.amc-resource-catalog .amc-resource-catalog__groups', label: 'Browse the full equipment directory'},
    {selector: '#amc179-home .amc179__cats', label: 'Explore equipment categories'}
  ];
  function restore() {
    document.querySelectorAll('#MainContent details.amc-mobile-home-disclosure').forEach(details => {
      const content = details.querySelector(':scope > [data-amc-mobile-directory]');
      if (!content || !details.parentNode) return;
      details.parentNode.insertBefore(content, details);
      content.removeAttribute('data-amc-mobile-directory');
      details.remove();
    });
  }
  function update() {
    if (!mq.matches) { restore(); return; }
    const main = document.querySelector('#MainContent');
    if (!main) return;
    selectors.forEach(({selector,label}) => {
      main.querySelectorAll(selector).forEach(content => {
        if (content.parentElement?.matches('details.amc-mobile-home-disclosure')) return;
        const wrapper = document.createElement('details');
        wrapper.className = 'amc-mobile-home-disclosure';
        const summary = document.createElement('summary');
        summary.textContent = label;
        content.parentNode.insertBefore(wrapper, content);
        wrapper.appendChild(summary);
        content.setAttribute('data-amc-mobile-directory', '');
        wrapper.appendChild(content);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, {once:true});
  } else update();
  mq.addEventListener?.('change', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', () => {
    if (!mq.matches) restore();
  });
})();
